var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column content-box"},[_c('woot-modal-header',{attrs:{"header-title":_vm.$t('INTEGRATION_SETTINGS.ASSISTENT.ADD.TITLE'),"header-content":_vm.useInstallationName(
        _vm.$t('INTEGRATION_SETTINGS.ASSISTENT.FORM.DESC'),
        _vm.globalConfig.installationName
      )}}),_vm._v(" "),_c('assistent-form',{attrs:{"is-submitting":_vm.uiFlags.creatingItem},on:{"submit":_vm.onSubmit,"cancel":_vm.onClose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }